<template>
  <div id="selfStudy_details">
    <div class="bottombox">
      <Header ref="header" />
      
    </div>
    <!-- bottombox end -->
    <div class="hotgkt">
      <div class="BreadcrumbNavigation">
        您当前所在位置：<a href="/">首页</a>>><router-link
          :to="{ path: 'selfStudy_list', query: { nav: 2 } }"
          >自学备考专区</router-link
        >>>
        <span>{{ allList.Title }}</span>
      </div>
    </div>
    <!-- hotgkt end -->
    <div class="main">
      <div class="main_ico clearfix">
        <div class="title">
          <span><em></em><strong>分类链接</strong></span>
        </div>
        <ul class="clearfix">
          <router-link
            :to="{ path: '/selfStudy_list/1', query: { nav: 2 } }"
            tag="li"
            ><img src="../../assets/selfStudy/main_ico1.png" /><span
              >政策动态</span
            ></router-link
          >
          <router-link
            :to="{ path: '/selfStudy_list/2', query: { nav: 2 } }"
            tag="li"
            ><img src="../../assets/selfStudy/main_ico2.png" /><span
              >备考规划</span
            ></router-link
          >
          <router-link
            :to="{ path: '/selfStudy_list/3', query: { nav: 2 } }"
            tag="li"
            ><img src="../../assets/selfStudy/main_ico3.png" /><span
              >备考资料</span
            ></router-link
          >
          <router-link
            :to="{ path: '/selfStudy_list/4', query: { nav: 2 } }"
            tag="li"
            ><img src="../../assets/selfStudy/main_ico4.png" /><span
              >入门常识</span
            ></router-link
          >
          <router-link
            :to="{ path: '/selfStudy_list/5', query: { nav: 2 } }"
            tag="li"
            ><img src="../../assets/selfStudy/main_ico5.png" /><span
              >报考相关</span
            ></router-link
          >
          <router-link
            :to="{ path: '/selfStudy_list/6', query: { nav: 2 } }"
            tag="li"
            ><img src="../../assets/selfStudy/main_ico6.png" /><span
              >费用相关</span
            ></router-link
          >
          <router-link
            :to="{ path: '/selfStudy_list/7', query: { nav: 2 } }"
            tag="li"
            ><img src="../../assets/selfStudy/main_ico7.png" /><span
              >复议流程</span
            ></router-link
          >
          <router-link
            :to="{ path: '/selfStudy_list/8', query: { nav: 2 } }"
            tag="li"
            ><img src="../../assets/selfStudy/main_ico8.png" /><span
              >考位查询</span
            ></router-link
          >
          <router-link
            :to="{ path: '/selfStudy_list/9', query: { nav: 2 } }"
            tag="li"
            ><img src="../../assets/selfStudy/main_ico9.png" /><span
              >考点相关</span
            ></router-link
          >
        </ul>
      </div>
      <!-- main_ico end -->
      <div class="main_details clearfix">
        <div class="title">
          <div class="title_watch">
            <h2>{{ allList.Title }}</h2>
            <p>阅读量( {{ allList.PageView }} )</p>
          </div>

          <p class="p1">{{ allList.AddTime }}</p>
          <p class="p2">#{{ ApplyStudentName.replace(/,/g, "#") }}</p>
          <p class="p3">摘要：{{ allList.Abstract }}</p>
        </div>
        <div class="centent clearfix">
          <p style="text-align: center;"><img :src="allList.CoverImg" /></p>
          <div v-html="allList.Content"></div>
        </div>
      </div>
      <!-- main_details end -->
      <div class="main_bottom" v-if="zsyc">
        <!-- main_bottom end -->
        <div class="title">
          <span><em></em><strong>热门公开课</strong></span>
        </div>
        <div class="mani_list">
          <ul class="clearfix">
            <li v-for="(items, index) in publicClass" :key="index">
              <!-- <a :href="items.JumpUrl"> -->
              <router-link
                :to="{
                  path: '/publicClass_details',
                  query: { KId: items.JumpUrl, nav: 3 }
                }"
              >
                <dl>
                  <dt>
                    <img :src="publicClass_imgs[index][0]" width="100%" />
                  </dt>
                  <dd>
                    <h2>{{ items.Title }}</h2>
                    <p class="p1">
                      #{{ publicClass_p[index].student.replace(/,/g, "#") }}
                    </p>
                    <p class="p2">{{ publicClass_p[index].time }}</p>
                    <div class="p3">
                      <em
                        ><img :src="publicClass_imgs[index][1]" width="100%"
                      /></em>
                      <span>{{ publicClass_p[index].teacher }}</span>
                      <strong>{{ publicClass_p[index].price }}</strong>
                    </div>
                  </dd>
                </dl>
              </router-link>
              <!-- </a> -->
            </li>
          </ul>
        </div>
      </div>
      <!-- main_bottom end -->
    </div>
    <!-- main end -->
  </div>
</template>

<script>
import Header from "../../components/header/Header.vue"; //公共头部

export default {
  name: "App",
  provide() {
    return {
      reload: this.reload
    };
  },
  components: {
    // 将组件隐射为标签,登陆弹窗
    Header,
    
  },
  metaInfo() {
    return {
      title: this.setting.title,
      meta: [
        {
          name: "keywords",
          content:
            "自学备考专区,雅思自学备考,雅思备考攻略,托福自学备考,托福备考攻略"
        },
        {
          name: "description",
          content:
            "启德考培在线,启德考培旗下官方网校.启德考培教师团队,讲授托福在线课程、雅思在线课程等出国考试在线课程."
        }
      ]
    };
  },
  data() {
    return {
      setting: {
        title: "启德考培旗下在线课堂_出国考试在线培训_考培网校"
      },
      tokenkey: "",
      publicClass: "", //广告循环
      kcID: "",
      ApplyStudentName: "",
      allList: {},
      comeOnPage: "", //进入该页面的时间戳
      goPage: "", //离开该页面的时间戳
      zsyc: false //暂时隐藏
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.targetUser = to.query.KId;
    });
  },
  watch: {
    pageNumber: function() {
      this.allList.PageView;
      // // console.log(this.allList.PageView)
    }
  },
  created: function() {
    //自动触发写入的函数
    let that = this;
    that.kcID = this.$route.query.KId;
    that.tokenkey = that.$cookies.get("token");
    that.comeOnPage = Date.parse(new Date()) / 1000;
    // // console.log(that.comeOnPage)

    // // console.log(that.kcID)
    that.$http
      .get(
        "https://schoolapi.eiceducation.com.cn/api/SelfStudyExam/" + that.kcID
      )
      .then(function(response) {
        //// console.log(response.data.results)
        that.allList = response.data.results;
        that.setting.title =
          that.allList.Title +
          " - 自学备考专区-启德考培在线_出国考试在线培训_考培网校";
        // // console.log(that.allList)
        that.ApplyStudentName = response.data.results.ApplyStudentName;
      })
      .catch(function() {
        // console.log('数据错误');
      });
    this.$http
      .get("https://schoolapi.eiceducation.com.cn/api/PageInfo?pageTypeId=6")
      .then(function(response) {
        //// console.log(response.data.results)
        that.publicClass = response.data.results.slice(0, 4);
        var bobao = [];
        var imgs = [];
        for (var i = 0; i < response.data.results.length; i++) {
          var bobao_xq = JSON.parse(response.data.results[i].MoreFieldsValue);
          var imgs_xq = response.data.results[i].ImageArrays.split(",");
          bobao.push(bobao_xq);
          imgs.push(imgs_xq);
        }
        that.publicClass_p = bobao;
        that.publicClass_imgs = imgs;
        // // console.log(bobao)
        // // console.log(imgs)
      })
      .catch(function() {
        // console.log('错误');
      });
  },
  mounted() {
  },
  methods: {},
  // 离开页面时提交时间
  beforeDestroy: function() {
    let that = this;
    this.goPage = Date.parse(new Date()) / 1000;
    let TimeInterval = this.goPage - this.comeOnPage;
    // // console.log(TimeInterval)
    // // console.log(that.tokenkey)
    this.$http
      .post(
        "https://schoolapi.eiceducation.com.cn/api/History",
        {
          ContentType: 49,
          ContentId: that.kcID,
          WatchTime: TimeInterval
        },
        {
          headers: {
            ContentType: "application/json",
            token: that.tokenkey
          }
        }
      )
      .then(function(result) {
        // // console.log(result)
      })
      .catch(function(error) {
        // console.log(error);
      });
  }
};
</script>

<style scoped>
.title_watch {
  display: flex;
  justify-content: space-between;
}

.title_watch p {
  line-height: 30px;
  font-size: 16px;
  color: #333333;
  padding-right: 15px;
}

.bottombox {
  box-shadow: 0px 3px 5px 0px rgba(233, 233, 233, 0.5);
  position: relative;
  z-index: 9;
}

.hotgkt {
  background: #ffffff;
}

.BreadcrumbNavigation {
  width: 1180px;
  text-align: left;
  font-size: 16px;
  color: #333;
  line-height: 56px;
  margin: 0 auto;
}

.BreadcrumbNavigation a {
  font-size: 16px;
  color: #333;
}

.BreadcrumbNavigation span {
  font-size: 16px;
  color: #ff4253;
}

.main {
  padding-bottom: 100px;
}

.main_ico {
  width: 1180px;
  margin: 0 auto;
  padding-top: 20px;
  margin-bottom: 54px;
}

.main_ico .title {
  height: 64px;
  text-align: center;
}

.main_ico .title span {
  display: inline-block;
  font-size: 28px;
  color: #333333;
  line-height: 56px;
  font-weight: 500;
  padding-right: 12px;
  padding-left: 13px;
  background: url(../../assets/publicClass/main_bottom2.png) right 34px
    no-repeat;
  position: relative;
}

.main_ico .title span em {
  position: absolute;
  left: 0;
  top: 0;
  width: 40px;
  height: 40px;
  background: url(../../assets/publicClass/main_bottom1.png) left top no-repeat;
}

.main_ico .title span strong {
  position: relative;
  font-weight: normal;
}

.main_ico ul {
  width: 100%;
  display: flex;
  justify-content: space-around;
}

.main_ico ul li {
  width: 70px;
  text-align: center;
}

.main_ico ul li img {
  display: block;
  margin: 0 auto;
}

.main_ico ul li span {
  font-size: 16px;
  line-height: 40px;
  color: #333;
}

.main_ico ul li a {
  display: block;
  transition: all 0.25s ease-in;
  -moz-transition: all 0.25s ease-in;
  -webkit-transition: all 0.25s ease-in;
}

.main_ico ul li a:hover {
  transform: translateY(-4px);
}

.main_details {
  width: 1180px;
  margin: 0 auto;
}

.main_details .title {
  text-align: left;
  margin-bottom: 20px;
}

.main_details .title h2 {
  width: 1000px;
  font-size: 24px;
  color: #333;
  line-height: 30px;
  margin-bottom: 20px;
}

.main_details .title .p1 {
  font-size: 16px;
  line-height: 16px;
  margin-bottom: 12px;
  color: #333;
}

.main_details .title .p2 {
  font-size: 16px;
  line-height: 16px;
  color: #ff9d00;
  margin-bottom: 10px;
}

.main_details .title .p3 {
  font-size: 16px;
  line-height: 28px;
  color: #333;
}

.main_details .centent div {
  font-size: 16px;
  line-height: 28px;
  color: #333;
  padding-bottom: 20px;
  text-align: left;
}

/* .main_bottom {
    width: 1180px;
    margin: 0 auto;
    padding-top: 66px;
    padding-bottom: 70px;
  }

  .main_bottom .title {
    height: 77px;
    text-align: center;
  }

  .main_bottom .title span {
    display: inline-block;
    font-size: 28px;
    color: #333333;
    line-height: 56px;
    font-weight: 500;
    padding-right: 12px;
    padding-left: 13px;
    background: url(../../assets/publicClass/main_bottom2.png) right 34px no-repeat;
    position: relative;
  }

  .main_bottom .title span em {
    position: absolute;
    left: 0;
    top: 0;
    width: 40px;
    height: 40px;
    background: url(../../assets/publicClass/main_bottom1.png) left top no-repeat;
  }

  .main_bottom .title span strong {
    position: relative;
    font-weight: normal;
  }

  .main_bottom_list {
    width: 1180px;
    margin: 0 auto;
  }

  .main_bottom_list ul li {
    width: 280px;
    height: 346px;
    float: left;
    background: #FFFFFF;
    box-shadow: 0px 0px 10px 6px rgba(245, 246, 246, 0.2);
    border-radius: 8px;
    overflow: hidden;
    margin-right: 20px;
    transition: all .25s ease-in;
    -moz-transition: all .25s ease-in;
    -webkit-transition: all .25s ease-in;
    position: relative;
  }

  .main_bottom_list ul li a {
    display: block;
    width: 100%;
    height: 100%;
  }

  .main_bottom_list ul li:hover {
    box-shadow: 0px 0px 6px 6px #F2F2F2;
  }

  .main_bottom_list ul li:nth-child(4n) {
    margin-right: 0;
  }

  .main_bottom_list ul li dt {
    width: 280px;
    height: 174px;
    overflow: hidden;
  }

  .main_bottom_list ul li dd {
    padding: 0 16px;
    padding-top: 20px;
    text-align: left;
  }

  .main_bottom_list ul li dd h2 {
    font-size: 16px;
    color: #333;
    line-height: 16px;
    margin-bottom: 8px;
    font-weight: normal;
  }

  .main_bottom_list ul li dd .p1 {
    width: 100%;
    font-size: 12px;
    color: #4E5CF6;
    line-height: 12px;
    margin-bottom: 8px;
    word-break: break-all;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .main_bottom_list ul li dd .p2 {
    font-size: 12px;
    color: #666;
    line-height: 12px;
    margin-bottom: 24px;
  }

  .main_bottom_list ul li dd .p3 {
    height: 38px;
  }

  .main_bottom_list ul li dd .p3 em {
    display: block;
    width: 34px;
    height: 34px;
    border: 2px #f5f6f6 solid;
    border-radius: 38px;
    float: left;
    overflow: hidden;
    margin-right: 8px;
  }

  .main_bottom_list ul li dd .p3 span {
    font-size: 14px;
    color: #333;
    line-height: 38px;
  }

  .main_bottom_list ul li dd .p3 strong {
    font-size: 24px;
    float: right;
    line-height: 38px;
    color: #333;

  }

  .main_bottom_list ul li dd .p4 {
    font-size: 12px;
    color: #666666;
    position: absolute;
    bottom: 17px;
    right: 16px;
  } */
.main_bottom {
  width: 1180px;
  margin: 0 auto;
  padding-top: 66px;
}

.main_bottom .title {
  height: 77px;
  text-align: center;
}

.main_bottom .title span {
  display: inline-block;
  font-size: 28px;
  color: #333333;
  line-height: 56px;
  font-weight: 500;
  padding-right: 12px;
  padding-left: 13px;
  background: url(../../assets/publicClass/main_bottom2.png) right 34px
    no-repeat;
  position: relative;
}

.main_bottom .title span em {
  position: absolute;
  left: 0;
  top: 0;
  width: 40px;
  height: 40px;
  background: url(../../assets/publicClass/main_bottom1.png) left top no-repeat;
}

.main_bottom .title span strong {
  position: relative;
  font-weight: normal;
}

.mani_list ul li {
  width: 280px;
  height: 346px;
  float: left;
  background: #ffffff;
  box-shadow: 0px 0px 10px 6px rgba(245, 246, 246, 0.2);
  border-radius: 8px;
  overflow: hidden;
  margin-right: 20px;
  margin-bottom: 20px;
  transition: all 0.25s ease-in;
  -moz-transition: all 0.25s ease-in;
  -webkit-transition: all 0.25s ease-in;
  position: relative;
}

.mani_list ul li:hover {
  box-shadow: 0px 0px 10px 6px #f5f6f6;
  transform: translateY(-8px);
}

.mani_list ul li:nth-child(4n) {
  margin-right: 0;
}

.mani_list ul li dt {
  width: 280px;
  overflow: hidden;
}

.mani_list ul li dd {
  padding: 0 16px;
  padding-top: 20px;
  text-align: left;
}

.mani_list ul li dd h2 {
  font-size: 16px;
  color: #333;
  line-height: 20px;
  margin-bottom: 8px;
  font-weight: normal;
  height: 40px;
}

.mani_list ul li dd .p1 {
  width: 100%;
  font-size: 12px;
  color: #ff9d00;
  line-height: 12px;
  margin-bottom: 8px;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mani_list ul li dd .p2 {
  font-size: 12px;
  color: #666;
  line-height: 12px;
  margin-bottom: 24px;
}

.mani_list ul li dd .p3 {
  height: 38px;
}

.mani_list ul li dd .p3 em {
  display: block;
  width: 34px;
  height: 34px;
  border: 2px #f5f6f6 solid;
  border-radius: 38px;
  float: left;
  overflow: hidden;
  margin-right: 8px;
}

.mani_list ul li dd .p3 span {
  font-size: 14px;
  color: #333;
  line-height: 38px;
}

.mani_list ul li dd .p3 strong {
  font-size: 24px;
  float: right;
  line-height: 38px;
  color: #333;
}
</style>



// WEBPACK FOOTER //
// src/page2/selfStudy/selfStudy_details.vue